import React from 'react';
import { PictureInput } from 'hyperdb-utils';

class PictureForm extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    // Dislay edited picture
    const { picture } = this.props;
    const img = document.querySelector('#preview');
    if (picture.original) {
      img.src = this.props.pictureUrl(picture, 'original');
    } else {
      img.style.display = 'none';
    }
  }
  render() {
    const props = this.props;
    return (
      <div className="row">
        <div className="col-sm-12 col-md-6">
          <img src="" alt="preview" id="preview" style={ { maxWidth: '100%', maxHeight: '280px', marginTop: '30px' } } />
        </div>
        <div className="col-sm-12 col-md-6">
          <PictureInput
            title="Picture"
            mode={ this.props.mode }
            picture={ props.picture }
            onChange={ this.handleChangePicture.bind(this) }
            availableLocales={ this.props.availableLanguages }
            defaultLanguage={ this.props.defaultLanguage }
            picturesList={ this.props.picturesList }
          />
          <br/>
          { props.uploadingPicture ? 'UPLOADING...' : '' }
        </div>
      </div>
    );
  }

  handleChangePicture(picture) {
    const file = picture.image_file;
    if (file) {
      readFileToBase64(file)
        .then(result => {
          if (result.content_type.match(/^image\/[png|jpg|jpeg|gif|wepb|svg]/)) {
            displayImage(result);
          }
        });
    }
    this.props.onChange(picture);
  }
}

function readFileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = function(e) {
      const buffer = e.target.result;
      resolve({
        filename: file.name,
        content_type: file.type,
        size: file.size,
        payload: arrayBufferToString(buffer, 'base64')
      });
    };
    reader.onerror = function(e) {
      reject(e.target.error);
    };
    reader.readAsArrayBuffer(file);
  });
}
function arrayBufferToString(buffer, encoding) {
  encoding = encoding || 'utf-8';
  let binary = '';
  const bytes = new Uint8Array(buffer);
  for (let i = 0, len = bytes.byteLength; i < len; i++) {
    binary += String.fromCharCode( bytes[ i ] );
  }
  switch (encoding) {
  case 'utf-8':
    return new TextDecoder('utf-8').decode(bytes);
  case 'binary':
  case 'ascii':
    return binary;
  case 'base64':
    return window.btoa(binary);
  default:
    throw Error('invalid encoding');
  }
}
function displayImage(data) {
  const imgsrc = 'data:' + data.content_type + ';base64,' + data.payload;
  document.getElementById('preview').src = imgsrc;
  document.getElementById('preview').style.display = 'block';
}

export default PictureForm;



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/property/components/PropertyEditor/PictureForm.jsx